import { tsl } from "./translations";

export const FE_SETTINGS = window['FrontendSettings'] as {
    promo_closingDelay: string,
    teamsystemBaseUrl: string,
    addPromoData_contractOid: string,
    addPromoData_applicationName: string,
    addPromoData_contextDescription: string,
    addPromoData_enabled: boolean,
    addPromoData_repeatVerify: boolean,
    addPromoData_signedForCompany: boolean,
    addPromoData_lCMSContractOid: string | null,
    addPromoData_proposerCode: string,
    addPromoData_excludeArchiving: boolean,
    addPromoData_proposerName: string,
    addPromoData_holderFiscalCode: string,
    addPromoData_holderVatCode: string,
    addPromoData_holderDescription: string,
    addPromoData_holderCountry: string,
};

export const Guid = {
    Empty: '00000000-0000-0000-0000-000000000000',
}

export const RGX = {
    Guid: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
    Email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    FiscalCode: /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i,
}

export const _ = {
    redirectTo: (path: string | null = FE_SETTINGS.teamsystemBaseUrl, token?: string, email?: string) => {

        if (token) {
            window.location.href = path ?
                `${path}/?email=${email}&token=${token}` :
                `${window.location.origin}/?email=${email}&token=${token}`
        } else {
            window.close();
            window.location.replace(path || FE_SETTINGS.teamsystemBaseUrl);
        }
    },
    redirectWithDelay: () => {
        const closingDelay = +FE_SETTINGS.promo_closingDelay;
        if (closingDelay) {
            setTimeout(() => {
                _.redirectTo();
            }, closingDelay);
        }
    },
    decodeHtml: (html: string) => {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    },
    verify: {
        fiscalCode: (fiscalCode: string) => {
            return RGX.FiscalCode.test(fiscalCode) ? '' : tsl.fiscalCodeValidationMsg;
        },
        email: (email: string) => {

            if (RGX.Email.test(email)) return '';
            else {
                return tsl.pecValidationMsg;
            }
        },
        email2: (email: string) => {

            if (RGX.Email.test(email)) return '';
            else {
                return tsl.emailValidationMsg;
            }
        },
        confirmEmail: (check: string, value: string) => {

            if (RGX.Email.test(check)) {
                if (check === value)
                    return '';
                else
                    return tsl.invalidEmailMatch;
            } else {
                return tsl.emailValidationMsg;
            }
        },
        confirmPec: (check: string, value: string) => {

            if (RGX.Email.test(check)) {
                if (check === value)
                    return '';
                else
                    return tsl.invalidEmailMatch;
            } else {
                return tsl.pecValidationMsg;
            }
        }
    }
}
